import React, { useState, useEffect } from "react"
import PageLayout from "../../../components/PageLayout"
import withRouter from "../../../components/Common/withRouter"
import { Card } from "@material-ui/core"
import MenuBar from "../../../components/Lystface/Settings/BillingDetails/MenuBar"
import Overview from "../../../components/Lystface/Settings/BillingDetails/Overview"
import Usages from "../../../components/Lystface/Settings/BillingDetails/Usages"
import BillingHistory from "../../../components/Lystface/Settings/BillingDetails/BillingHistory"
import SavedCards from "../../../components/Lystface/Settings/BillingDetails/SavedCards"
import { createSelector } from "reselect"
import { useSelector, useDispatch } from "react-redux"
import { getCardList, getInvoices, getPlan, getBillAdd, getTimeZonesList, setSetupPopup, setPayementInformation } from "../../../store/actions"
import { BillingAddress } from "../../../components/Lystface/Settings/BillingDetails/BillingAddress"
import { Navigate, useNavigate } from "react-router-dom"
import Cookies from 'js-cookie'
import CustomPopup from "../../../components/Common/CustomPopup"
import TimeZone from "../../../components/Lystface/Settings/BillingDetails/TimeZone"
import PaymentInformation from "../../../components/Lystface/Settings/BillingDetails/PaymentInformation"
import { getPlanSpecificationDetails } from "../../../store/menu/home/actions"
import CustomCard from "../../../components/Common/CustomCard"
import { appConstants } from "../../../constants/app_constants"

const DynamicPage = [
  {
    title: "Overview",
    component: <Overview />,
    id: "overview"
  },
  {
    title: "Billing history",
    component: <BillingHistory />,
    id: "billing-history"
  },
  {
    title: "Timezone",
    component: <BillingAddress />,
    id: "time-zone"
  },
  {
    title: "Payment information",
    component: <PaymentInformation />,
    id: "payment-information"

  },


]



const BillingDetails = props => {
  const dispatch = useDispatch()
  const BillSetState = state => state.BillSet
  const BillSetProperties = createSelector(BillSetState, UserBillSet => ({
    repMessage: UserBillSet.repMessage,
    loading: UserBillSet.loading,
    addCardErr: UserBillSet.addCardErr,
    cardList: UserBillSet.cardList,
    cardListLoading: UserBillSet.cardListLoading,
    cardAction: UserBillSet.cardAction,
    invList: UserBillSet.invList,
    invListLoading: UserBillSet.invListLoading,
    planDetails: UserBillSet.planDetails,
    cardAdded: UserBillSet.cardAdded,
    billAddress: UserBillSet.billAddress,
    getBillAddressLoading: UserBillSet.getBillAddressLoading,
    billAddressLoading: UserBillSet.billAddressLoading,
    editBillAddressLoading: UserBillSet.editBillAddressLoading,
    defCardErr: UserBillSet.defCardErr,
    remCardErr: UserBillSet.remCardErr,
    editBillAddErr: UserBillSet.editBillAddErr,
    addBillAddErr: UserBillSet.addBillAddErr,
    defaultCardLoading: UserBillSet?.defaultCardLoading,
    cardRemoveLoading: UserBillSet?.cardRemoveLoading,
    billAdressFetched: UserBillSet?.billAdressFetched,
    timeZonesDetails: UserBillSet?.timeZonesDetails,
    setupPopup: UserBillSet?.setupPopup,
    setPayementInfo: UserBillSet?.setPayementInfo
  }))
  const {
    repMessage,
    loading,
    cardAction,
    addCardErr,
    defCardErr,
    editBillAddErr,
    remCardErr,
    cardList,
    cardListLoading,
    invList,
    invListLoading,
    cardAddLoading,
    cardAdded,
    billAddress,
    billAddressLoading,
    editBillAddressLoading,
    getBillAddressLoading,
    addBillAddErr,
    defaultCardLoading,
    cardRemoveLoading,
    billAdressFetched,
    timeZonesDetails,
    setupPopup,
    setPayementInfo
  } = useSelector(BillSetProperties)
  const mystate = useSelector(state => state.BillSet)
  const ConstDetailsProp = useSelector(state => state.Login.constDetails)
  const { billing_setup, card_setup, userName } = ConstDetailsProp
  const planSpecificaionState = useSelector(state => state.Home?.planSpecificationDetails)
  const { plan: planDetails, loading: planDetLoading } = planSpecificaionState
  const searchParam = props?.router?.location?.search?.split("=")[1]

  const [active, setActive] = useState(searchParam ? searchParam : setPayementInfo?.from === "payment-information" ? "payment-information" : DynamicPage[0]?.id)

  const pageName = "Settings"
  const moduleName = "Billing details"


  const breadcrumbItems = [
    { text: "Home", link: "/" },
    { text: pageName, link: "#" },
    { text: moduleName, link: "#" },
  ]



  let navigate = useNavigate();

  const onActiveMenuHandler = activeMenuId => {
    setActive(activeMenuId)
  }
  useEffect(() => {
    if (active === "overview") {
      dispatch(getPlanSpecificationDetails())

    }
    if (active === "payment-information") {
      dispatch(getCardList())

    }
    if (active === "billing-history") {
      dispatch(getInvoices({ status: "" }))

    }

    if (active === "payment-information") {
      dispatch(getBillAdd())

    }
    if (active === "time-zone" && !timeZonesDetails?.listofTimeZones) {
      dispatch(getTimeZonesList())

    }
  }, [active])

  useEffect(() => {
    if (setPayementInfo?.from === "payment-information") {
      setActive("payment-information")
      dispatch(setPayementInformation({ from: null }))

    }

  }, [setPayementInfo])






  const handleClickPrimaryButton = () => {
    setPopupDetails({ open: false })
    dispatch(setSetupPopup())
  }


  const [popupDetails, setPopupDetails] = useState({
    open: true, titleText: `Hi ${userName},`, title: 'setup',
    bodyText: <div className="billing"><p>Welcome to {appConstants.cName} API!</p><p>To activate your trial plan, kindly add the billing information.</p><span>Please note that charges will be applied once the trial period is completed.</span></div>,
    primaryButtonText: 'Ok', handleClickPrimaryButton: handleClickPrimaryButton
  })
  return (
    <React.Fragment>
      <PageLayout pageName={pageName} breadcrumbItems={breadcrumbItems}>
        <Card className="layout-card m-0">
          <MenuBar activeMenu={onActiveMenuHandler} menuList={(billing_setup && card_setup) ? DynamicPage : DynamicPage} active={active} billing_setup={billing_setup} />
          {active === "time-zone" && (
            <TimeZone
              timeZonesDetails={timeZonesDetails}
            />
          )}
          {active === "overview" && (
            <>
              <Overview
                planDetails={planDetails}
                planDetLoading={planDetLoading}
              />
            </>

          )}
          {active === "billing-history" && (
            <BillingHistory invList={invList} invListLoading={invListLoading} />
          )}

          {active === "payment-information" && (
            <PaymentInformation billAddress={billAddress} cardList={cardList} />
          )}
        </Card>
        {/* {active === 0 && (
          <Card className="layout-card">
            <Usages />
          </Card>
        )} */}

      </PageLayout>
    </React.Fragment>
  )
}

export default withRouter(BillingDetails)
